module.exports = __webpack_public_path__ + "img/ubm-pc4.367658a1.png";